import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=808765de&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=js"
export * from "./PopupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808765de",
  null
  
)

export default component.exports